import React, { Component } from 'react'
import { Provider } from "react-redux"
import trans from "trans"

import { Button, Icon, modal } from '@bdfx/mergado-ui-kit'

import store from "store"
import PreviewModalWrapper from "./preview-modal-wrapper"
import { iconSize } from "./tools-panel"
import { ID } from 'app/types/app-types'
import { LevelsModeType } from './save-template-form'

export interface Props {
    handleImageRefresh: Function
    sameImageInPreview: boolean
    templateId: ID
    altTemplateId: ID
    levels: string[]
    levelsMode: LevelsModeType
}

class PreviewModal extends Component<Props> {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Button
                color="nocolor"
                size="tiny"
                title={trans('preview')}
                icon={<Icon type={'eye'} size={iconSize} />}
                style={{ borderTop: '1px solid #ddd', borderRadius: 0 }}
                onClick={() => {
                    modal({
                        overlayClassName: 'image-preview-wrapper-modal',
                        closeOnEscape: true,
                        closeOnClickOutside: true,
                        title: ' ',
                        /* fullscreen: false, */
                        style: { maxWidth: '90vw', maxHeight: '90vh', minWidth: '60vw', overflow: 'hidden', ' .DialogTitle': {display: 'none'} },
                        message: (close) => <Provider store={store}>
                            <PreviewModalWrapper
                                handleImageRefresh={this.props.handleImageRefresh}
                                sameImageInPreview={this.props.sameImageInPreview}
                                templateId={this.props.templateId}
                                altTemplateId={this.props.altTemplateId}
                                levels={this.props.levels}
                                levelsMode={this.props.levelsMode}
                                close={close}
                            />
                        </Provider>,
                    })
                }}
            />
        )
    }
}


export default PreviewModal
